import React, { useState, useRef, useEffect, Fragment } from "react";
import {
  setTopScroll,
  setChapter,
  setSection,
  setDragScroll,
} from "../Store/ui/reader";
import { useDispatch, useSelector } from "react-redux";
import Draggable from "./Draggable";
const DraggableSidebar = ({
  scrollBook = () => {},
  scrollCentre = () => {},
  scrollToChapter = () => {},
  scrollToParagraph = () => {},
  scrollToSection = () => {},
  setScrollToId,
  setParentIsScrolling = () => {},
  isScrolling = false,
}) => {
  const { book } = useSelector((state) => state.entities);
  const [top, setTop] = useState(0);
  const [selectedActivity, setSelctedActivity] = useState("");
  const { reader } = useSelector((state) => state.ui.reader);
  const { chapter, section, topScroll } = reader;
  const dispatch = useDispatch();
  const totalTextLength = book.chapters.reduce(
    (tot, chapter) =>
      tot +
      chapter.sections.reduce(
        (acc, ele) =>
          acc +
          ele.paragraphs.reduce(
            (acc2, ele2) =>
              acc2 + ele2.text?.replace(/<\/?[^>]+(>|$)/g, "").length,
            0
          ),
        0
      ),
    0
  );

  const totalQuestions = book.chapters.reduce(
    (chapAcc, chap) =>
      chapAcc +
      chap.sections.reduce(
        (secAcc, sec) =>
          secAcc +
          book.activities
            .filter((e) => e.chapter === chap._id && e.section === sec._id)
            .reduce((actAcc, act) => actAcc + act.questions.length, 0),
        0
      ),
    0
  );
  const toggleScrolling = (isEnable) => {
    if (isEnable) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    } else {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    }
  };
  const scrollerRef = useRef(null);

  useEffect(() => {
    toggleScrolling(isScrolling);
    return () => {
      toggleScrolling(false);
    };
  }, [isScrolling]);

  useEffect(() => {
    if (scrollerRef.current) {
      const child = document.getElementById(`chap.${chapter}`);
      const topR = getChildTop(scrollerRef.current, child);
      // dispatch(setTopScroll(topR));
    }
  }, [scrollerRef.current, chapter]);

  const onMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // event.stopPropagation();
    setParentIsScrolling(true);
    const { scrollTop } = scrollerRef.current;
    setTop(scrollTop);
    const position = scrollTop - top + event.clientY;
    scrollCentre(
      ((scrollTop - top + event.clientY) / scrollerRef.current.clientHeight) *
        100
    );
    scrollerRef.current.scrollTop = scrollTop - top + event.clientY;
    const childElement = getChildAtPosition(scrollerRef.current, position);

    if (childElement) {
      // child element found
      const childs = childElement.children;
      const id = childs[0].dataset.id;
      const name = childs[0].dataset.name;
      if (name === "activity") {
        const scrId = childs[0].dataset.secid;
        const chapId = book.chapters.findIndex(
          (e) => e._id === scrId.split(".")[0]
        );

        scrollBook(
          book.chapters[chapId].sections.findIndex(
            (e) => e._id === scrId.split(".")[1]
          ) || 0,
          chapId,
          scrId.split(".")[2]
        );
        dispatch(setSection(0));
        setScrollToId(scrId);
      } else if (id) {
        // scrollBook(Number(id.split(".")[1]), Number(id.split(".")[0]));
        dispatch(setSection(Number(id.split(".")[1])));
        dispatch(setChapter(Number(id.split(".")[0])));
      }
    }
    dispatch(setTopScroll(event.clientY));
  };

  const onMouseMove = (event) => {
    if (!isScrolling) return;
    event.preventDefault();
    const { clientY: y } = event;
    const { scrollTop } = scrollerRef.current;
    //pass the top scroll in percentage to the function
    // scrollCentre(scrollTop - top + y);
    scrollCentre(
      ((scrollTop - top + y) / scrollerRef.current.clientHeight) * 100
    );
    scrollerRef.current.scrollTop = scrollTop - top + y;
    if (scrollTop - top + y <= 0) {
      dispatch(setTopScroll(0));
    } else if (scrollTop - top + y > 1000) {
      dispatch(setTopScroll(1000));
    } else {
      dispatch(setTopScroll(scrollTop - top + y));
    }

    const position = scrollTop - top + y;
    const childElement = getChildAtPosition(scrollerRef.current, position);
    if (childElement) {
      // child element found
      const childs = childElement.children;
      const id = childs[0].dataset.id;
      if (id) {
        const section = Number(id.split(".")[1]);
        const chapter = Number(id.split(".")[0]);
        dispatch(setSection(section));
        dispatch(setChapter(chapter));
        scrollBook(section, chapter);
      }
    }
  };

  const onMouseUp = (event) => {
    setParentIsScrolling(false);
    // setTop(0)
  };

  const attachScroller = (scroller) => {
    scrollerRef.current = scroller;
  };

  function getChildAtPosition(parentElement, position) {
    const { top } = parentElement.getBoundingClientRect();
    const children = Array.from(parentElement.children);
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const { top: childTop, height } = child.getBoundingClientRect();
      const childPosition = childTop - top;

      if (position >= childPosition && position <= childPosition + height) {
        return child;
      }
    }
    return null;
  }

  function getChildTop(parentElement, targetChildElement) {
    const { top } = parentElement.getBoundingClientRect();
    const children = Array.from(parentElement.children);

    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if (child === targetChildElement) {
        const { top: childTop } = child.getBoundingClientRect();
        return childTop - top;
      }
    }
    return null;
  }

  return (
    <div
      className="scroller"
      ref={attachScroller}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={(e) => {
        setParentIsScrolling(false);
      }}
    >
      <div>
        <Draggable />
      </div>
      {/* <div className="child" style={{ background: "green", height: 20 }}/> */}

      {/*book.chapters.map((chapter, chapIndex) => (
                <div key={chapIndex} id={"chap." + chapIndex}>
                    {chapter.sections.map((section, secIndex) => (
                        <div
                            style={{
                                height: `${(section.paragraphs.reduce((acc, ele) => acc + ele.text.length, 0)) / totalTextLength * 800}px`,
                            }}
                            key={`${chapIndex}-${secIndex}`}
                            data-id={`${chapIndex}.${secIndex}`}
                            id={`${chapIndex}.${secIndex}`}
                        >
                            {section.activities.map((activity, actIndex) => (
                                <div style={{
                                    marginTop: `${activity.questions.length / totalQuestions * 100}px`,
                                    height: `${activity.questions.length / totalQuestions * 100}px`,
                                    borderRadius: 2,
                                    background: `${activity.assigned ? "#6700B2" : "gray"}`,
                                    cursor: "pointer"
                                }}
                                    onClick={(e) => selectActivity(e, chapIndex, secIndex, `${chapIndex}-${secIndex}-${actIndex}`)}
                                    key={`${chapIndex}-${secIndex}-${actIndex}`}
                                    className={selectedActivity === `${chapIndex}-${secIndex}-${actIndex}` ? 'selectedAct' : ""}
                                >
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            ))*/}

      {book.chapters.map((chapter, chapIndex) => (
        <div
          key={chapIndex}
          id={"chap." + chapIndex}
          onMouseDown={(e) => {
            setParentIsScrolling(true);
          }}
          // onMouseMove={(e) => chapterScroll(e, chapIndex)}
          style={{
            // height: `${
            //   (chapter.sections.reduce(
            //     (secAcc, sec) =>
            //       secAcc +
            //       sec.paragraphs.reduce(
            //         (pAcc, p) => (p.text ? pAcc + p.text.length : pAcc + 0),
            //         0
            //       ),
            //     0
            //   ) /
            //     totalTextLength) *
            //   80
            // }vh`
            height: `${
              (chapter.sections.reduce(
                (secAcc, sec) =>
                  secAcc +
                  sec.paragraphs.reduce(
                    (pAcc, p) =>
                      pAcc + p.text?.replace(/<\/?[^>]+(>|$)/g, "").length,
                    0
                  ),
                0
              ) /
                totalTextLength) *
              80
            }vh`,
          }}
        >
          {book.activities
            .filter(
              (e) =>
                e.chapter === chapter._id && !e.section && !e.paragraphs.length
            )
            .map((activity, actIndex) => (
              <div
                style={{
                  // marginTop: `${
                  //   (activity.questions.length / totalQuestions) * 5
                  // }vh`,
                  // height: `${
                  //   (activity.questions.length / totalQuestions) * 5
                  // }vh`,
                  height: 5,
                  borderRadius: 2,
                  background: `${activity.assigned ? "#6700B2" : "gray"}`,
                  cursor: "pointer",
                }}
                // onClick={(e) => selectActivity(e, chapIndex, secIndex, `${chapIndex}-${actIndex}`)}
                key={`${chapIndex}-${actIndex}`}
                data-name="activity"
                data-secid={chapter._id}
                onMouseDown={(e) => {
                  e.stopPropagation();
                  scrollToSection(0, chapIndex);
                  scrollToChapter(chapter._id, chapIndex);
                  dispatch(setSection(0));
                  dispatch(setChapter(chapIndex));
                  dispatch(setTopScroll(e.clientY));
                }}
              ></div>
            ))}
          {chapter.sections.map((section, secIndex) => (
            <div
              // style={{
              //   height: `${
              //     (section.paragraphs.reduce(
              //       (acc, ele) =>
              //         acc + ele.text
              //           ? ele.text.length
              //           : ele.image && ele.image.description
              //           ? ele.image.description.length
              //           : 1,
              //       0
              //     ) /
              //       totalTextLength) *
              //     80
              //   }vh`
              // }}
              key={`${chapIndex}-${secIndex}`}
              data-id={`${chapIndex}.${secIndex}`}
            >
              {book.activities
                .filter(
                  (e) =>
                    e.chapter === chapter._id &&
                    e.section === section._id &&
                    !e.paragraphs.length
                )
                .map((activity, actIndex) => (
                  <div
                    style={{
                      marginTop: `${
                        (activity.questions.length / totalQuestions) * 5
                      }vh`,
                      height: 5,
                      borderRadius: 2,
                      background: `${activity.assigned ? "#6700B2" : "gray"}`,
                      cursor: "pointer",
                    }}
                    onClick={(e) => {}}
                    key={`${chapIndex}-${secIndex}-${actIndex}`}
                    data-name="activity"
                    data-secid={chapter._id + "." + section._id}
                    className={
                      selectedActivity ===
                      `${chapIndex}-${secIndex}-${actIndex}`
                        ? "selectedAct"
                        : ""
                    }
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      scrollToSection(secIndex, chapIndex);
                      dispatch(setSection(secIndex));
                      dispatch(setChapter(chapIndex));

                      dispatch(setTopScroll(e.clientY));
                    }}
                  ></div>
                ))}
              {section.paragraphs.map((p, pindex) => (
                <div key={pindex}>
                  {/*<p style={{fontSize:"1px", visibility:"hidden"}}>{p.text}</p>*/}
                  {book.activities
                    .filter((e) => e.paragraphs.includes(p._id))
                    .map((activity, actIndex) => (
                      <div
                        style={{
                          marginTop: "0.5px",
                          height: 5,
                          borderRadius: 2,
                          background: `${
                            activity.assigned ? "#6700B2" : "gray"
                          }`,
                          cursor: "pointer",
                        }}
                        onClick={
                          (e) => {
                            // setScrollToId(
                            //   `${chapter._id}.${section._id}.${p._id}`
                            // );
                            // e.stopPropagation();
                            // scrollPara(chapIndex, secIndex, pindex);
                          }
                          // selectActivity(
                          //   e,
                          //   chapIndex,
                          //   secIndex,
                          //   `${chapIndex}-${secIndex}-${actIndex}`
                          // )
                        }
                        key={`${chapIndex}-${secIndex}-${actIndex}`}
                        data-name="activity"
                        data-secid={`${chapter._id}.${section._id}.${p._id}`}
                        className={
                          selectedActivity ===
                          `${chapIndex}-${secIndex}-${actIndex}`
                            ? "selectedAct"
                            : ""
                        }
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          scrollToSection(secIndex, chapIndex);
                          scrollToParagraph(chapter._id, section._id, p._id);
                          dispatch(setSection(secIndex));
                          dispatch(setChapter(chapIndex));

                          dispatch(setTopScroll(e.clientY));
                        }}
                      ></div>
                    ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DraggableSidebar;
